import { ComposeViewState } from 'owa-mail-compose-store';
import { mutatorAction } from 'satcheljs';
import { InternetHeaders } from 'owa-addins-core';

export default mutatorAction(
    'setInternetHeaders',
    (viewState: ComposeViewState, newDictionary: InternetHeaders) => {
        viewState.internetHeaders = viewState.internetHeaders.merge(newDictionary);
        viewState.isDirty = true;
    }
);
